import axios from 'axios'
const url = 'https://www.lefisc.com.br/api/planejar/' 
const chave = 'ac01f493e125988aef73d5afc8152be5'
export default {
    ecfBuscar(file) {
        const formData = new FormData();
        formData.append('file', file);
        return axios
            .post(`https://www.lefisc.com.br/sandbox4/arquivo/upload`, formData)
            .then(res => res.data)
            .catch(err => console.log(err));
    },
    infoBuscar(objInfo) {
        return axios
            .post(`${url}informacoes/buscar`, 
            {
                "grupo": objInfo
            }
                )
            .then(res => res.data)
            .catch(err => console.log(err));
    },
    enviaMercados(objCnae,estado,iss) {
        return axios
            .post(`${url}calcularDeducoes/${chave}`, {
                "estado": estado,
                "iss": iss,
                "listaReceitas": objCnae
            }
                )
            .then(res => res.data)
            .catch(err => console.log(err));
    },
    buscarCNAE(cnae) {
        return axios
            .post(`${url}buscarCNAE/${chave}`, 
            {
                "CNAE":
                [
                    cnae
                ]    
            }
            )
            .then(res => res.data)
            .catch(res => res.data);
    },
    calcular(objCnae,meses,estado,idcliente,irpj, csll, previdencia, ipi, ecf, tipoEcf) {
        console.log( meses[0][12][18])
        return axios
            .post(`${url}calcular/${chave}/${idcliente}`,
            
            {
                
                "tipoEcf": tipoEcf,
                "ecf": ecf,
                "tributos": {
                    "irpj": [ {
                        "mes": 1,
                        "valor": irpj[0].valor
                    },
                    {
                        "mes": 2,
                        "valor": irpj[1].valor
                    },
                    {
                        "mes": 3,
                        "valor": irpj[2].valor
                    },
                    {
                        "mes": 4,
                        "valor": irpj[3].valor
                    },
                    {
                        "mes": 5,
                        "valor": irpj[4].valor
                    },
                    {
                        "mes": 6,
                        "valor": irpj[5].valor
                    },
                    {
                        "mes": 7,
                        "valor": irpj[6].valor
                    },
                    {
                        "mes": 8,
                        "valor": irpj[7].valor
                    },
                    {
                        "mes": 9,
                        "valor": irpj[8].valor
                    },
                    {
                        "mes": 10,
                        "valor": irpj[9].valor
                    },
                    {
                        "mes": 11,
                        "valor": irpj[10].valor
                    },
                    {
                        "mes": 12,
                        "valor": irpj[11].valor
                    } ],
                    "csll": [ {
                        "mes": 1,
                        "valor": csll[0].valor
                    },
                    {
                        "mes": 2,
                        "valor": csll[1].valor
                    },
                    {
                        "mes": 3,
                        "valor": csll[2].valor
                    },
                    {
                        "mes": 4,
                        "valor": csll[3].valor
                    },
                    {
                        "mes": 5,
                        "valor": csll[4].valor
                    },
                    {
                        "mes": 6,
                        "valor": csll[5].valor
                    },
                    {
                        "mes": 7,
                        "valor": csll[6].valor
                    },
                    {
                        "mes": 8,
                        "valor": csll[7].valor
                    },
                    {
                        "mes": 9,
                        "valor": csll[8].valor
                    },
                    {
                        "mes": 10,
                        "valor": csll[9].valor
                    },
                    {
                        "mes": 11,
                        "valor": csll[10].valor
                    },
                    {
                        "mes": 12,
                        "valor": csll[11].valor
                    } ],
                    "ipi": [ {
                        "mes": 1,
                        "valor": ipi[0].valor
                    },
                    {
                        "mes": 2,
                        "valor": ipi[1].valor
                    },
                    {
                        "mes": 3,
                        "valor": ipi[2].valor
                    },
                    {
                        "mes": 4,
                        "valor": ipi[3].valor
                    },
                    {
                        "mes": 5,
                        "valor": ipi[4].valor
                    },
                    {
                        "mes": 6,
                        "valor": ipi[5].valor
                    },
                    {
                        "mes": 7,
                        "valor": ipi[6].valor
                    },
                    {
                        "mes": 8,
                        "valor": ipi[7].valor
                    },
                    {
                        "mes": 9,
                        "valor": ipi[8].valor
                    },
                    {
                        "mes": 10,
                        "valor": ipi[9].valor
                    },
                    {
                        "mes": 11,
                        "valor": ipi[10].valor
                    },
                    {
                        "mes": 12,
                        "valor": ipi[11].valor
                    } ],
                    "PrevidenciaSocial": [ {
                        "mes": 1,
                        "valor": previdencia[0].valor
                    },
                    {
                        "mes": 2,
                        "valor": previdencia[1].valor
                    },
                    {
                        "mes": 3,
                        "valor": previdencia[2].valor
                    },
                    {
                        "mes": 4,
                        "valor": previdencia[3].valor
                    },
                    {
                        "mes": 5,
                        "valor": previdencia[4].valor
                    },
                    {
                        "mes": 6,
                        "valor": previdencia[5].valor
                    },
                    {
                        "mes": 7,
                        "valor": previdencia[6].valor
                    },
                    {
                        "mes": 8,
                        "valor": previdencia[7].valor
                    },
                    {
                        "mes": 9,
                        "valor": previdencia[8].valor
                    },
                    {
                        "mes": 10,
                        "valor": previdencia[9].valor
                    },
                    {
                        "mes": 11,
                        "valor": previdencia[10].valor
                    },
                    {
                        "mes": 12,
                        "valor": previdencia[11].valor
                    } ],
                },
                "estado": estado,
                "receitas": {
                    "listaReceitas": objCnae
                },
                "deducoes": {
                    "icms": [ {
                        "mes": 1,
                        "valor": meses[0][4][0].valor
                    },
                    {
                        "mes": 2,
                        "valor": meses[1][4][0].valor
                    },
                    {
                        "mes": 3,
                        "valor": meses[2][4][0].valor
                    },
                    {
                        "mes": 4,
                        "valor": meses[3][4][0].valor
                    },
                    {
                        "mes": 5,
                        "valor": meses[4][4][0].valor
                    },
                    {
                        "mes": 6,
                        "valor": meses[5][4][0].valor
                    },
                    {
                        "mes": 7,
                        "valor": meses[6][4][0].valor
                    },
                    {
                        "mes": 8,
                        "valor": meses[7][4][0].valor
                    },
                    {
                        "mes": 9,
                        "valor": meses[8][4][0].valor
                    },
                    {
                        "mes": 10,
                        "valor": meses[9][4][0].valor
                    },
                    {
                        "mes": 11,
                        "valor": meses[10][4][0].valor
                    },
                    {
                        "mes": 12,
                        "valor": meses[11][4][0].valor
                    } ],
                    "pis_LR": [
                        {
                            "mes": 1,
                            "valor": meses[0][4][1].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][4][1].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][4][1].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][4][1].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][4][1].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][4][1].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][4][1].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][4][1].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][4][1].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][4][1].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][4][1].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][4][1].valor
                        } 
                     ],
                    "cofins_LR": [ 
                        {
                            "mes": 1,
                            "valor": meses[0][4][2].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][4][2].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][4][2].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][4][2].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][4][2].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][4][2].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][4][2].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][4][2].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][4][2].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][4][2].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][4][2].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][4][2].valor
                        } 
                    ],
                    "pis_LP": [ 
                        {
                            "mes": 1,
                            "valor": meses[0][4][3].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][4][3].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][4][3].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][4][3].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][4][3].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][4][3].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][4][3].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][4][3].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][4][3].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][4][3].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][4][3].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][4][3].valor
                        } 
                     ],
                    "cofins_LP": [
                        {
                            "mes": 1,
                            "valor": meses[0][4][4].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][4][4].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][4][4].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][4][4].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][4][4].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][4][4].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][4][4].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][4][4].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][4][4].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][4][4].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][4][4].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][4][4].valor
                        } 
                     ],
                    "iss": [
                        {
                            "mes": 1,
                            "valor": meses[0][4][5].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][4][5].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][4][5].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][4][5].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][4][5].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][4][5].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][4][5].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][4][5].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][4][5].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][4][5].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][4][5].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][4][5].valor
                        } 
                     ]
                },
                "custosDespesas": {
                    "comprasMateriaPrima": [
                        {
                            "mes": 1,
                            "valor": meses[0][6][1].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][6][1].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][6][1].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][6][1].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][6][1].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][6][1].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][6][1].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][6][1].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][6][1].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][6][1].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][6][1].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][6][1].valor
                        } 
                     ],
                     "comprasMercadorias": [
                        {
                            "mes": 1,
                            "valor": meses[0][6][4].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][6][4].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][6][4].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][6][4].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][6][4].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][6][4].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][6][4].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][6][4].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][6][4].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][6][4].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][6][4].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][6][4].valor
                        } 
                     ],
                    "insumos": [ 
                        {
                            "mes": 1,
                            "valor": meses[0][6][6].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][6][6].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][6][6].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][6][6].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][6][6].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][6][6].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][6][6].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][6][6].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][6][6].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][6][6].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][6][6].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][6][6].valor
                        } 
                    ]
                },
                "demaisCustos": {
                    "energia": [
                        {
                            "mes": 1,
                            "valor": meses[0][7][0].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][7][0].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][7][0].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][7][0].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][7][0].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][7][0].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][7][0].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][7][0].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][7][0].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][7][0].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][7][0].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][7][0].valor
                        } 
                     ],
                     "total": [
                        {
                            "mes": 1,
                            "valor": meses[0][7][10].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][7][10].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][7][10].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][7][10].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][7][10].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][7][10].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][7][10].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][7][10].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][7][10].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][7][10].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][7][10].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][7][10].valor
                        } 
                     ]
                },
                "folhaPagamento": {
                    "proLabore": [
                        {
                            "mes": 1,
                            "valor": meses[0][8][0].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][8][0].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][8][0].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][8][0].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][8][0].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][8][0].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][8][0].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][8][0].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][8][0].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][8][0].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][8][0].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][8][0].valor
                        } 
                     ],
                    "salarios": [
                        {
                            "mes": 1,
                            "valor": meses[0][8][1].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][8][1].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][8][1].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][8][1].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][8][1].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][8][1].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][8][1].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][8][1].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][8][1].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][8][1].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][8][1].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][8][1].valor
                        } 
                     ],
                    "servicosTerceiros": [
                        {
                            "mes": 1,
                            "valor": meses[0][8][2].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][8][2].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][8][2].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][8][2].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][8][2].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][8][2].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][8][2].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][8][2].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][8][2].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][8][2].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][8][2].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][8][2].valor
                        } 
                     ]
                },
                "despesasOperacionaisGerais": {
                    "alugueis": [
                        {
                            "mes": 1,
                            "valor": meses[0][9][0].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][9][0].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][9][0].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][9][0].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][9][0].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][9][0].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][9][0].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][9][0].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][9][0].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][9][0].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][9][0].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][9][0].valor
                        } 
                    ],
                    "contraprestacoes": [
                        {
                            "mes": 1,
                            "valor": meses[0][9][1].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][9][1].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][9][1].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][9][1].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][9][1].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][9][1].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][9][1].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][9][1].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][9][1].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][9][1].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][9][1].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][9][1].valor
                        } 
                    ],
                    "armazenagem": [
                        {
                            "mes": 1,
                            "valor": meses[0][9][2].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][9][2].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][9][2].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][9][2].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][9][2].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][9][2].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][9][2].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][9][2].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][9][2].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][9][2].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][9][2].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][9][2].valor
                        } 
                    ],
                    "encargos": [
                        {
                            "mes": 1,
                            "valor": meses[0][9][3].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][9][3].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][9][3].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][9][3].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][9][3].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][9][3].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][9][3].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][9][3].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][9][3].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][9][3].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][9][3].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][9][3].valor
                        } 
                    ],
                    "previdenciaPrivada": [
                        {
                            "mes": 1,
                            "valor": meses[0][10][5].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][10][5].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][10][5].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][10][5].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][10][5].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][10][5].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][10][5].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][10][5].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][10][5].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][10][5].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][10][5].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][10][5].valor
                        } 
                    ],
                    "gratificacao": [
                        {
                            "mes": 1,
                            "valor": meses[0][10][7].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][10][7].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][10][7].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][10][7].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][10][7].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][10][7].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][10][7].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][10][7].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][10][7].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][10][7].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][10][7].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][10][7].valor
                        } 
                    ],
                    "brindes": [
                        {
                            "mes": 1,
                            "valor": meses[0][11][1].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][11][1].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][11][1].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][11][1].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][11][1].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][11][1].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][11][1].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][11][1].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][11][1].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][11][1].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][11][1].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][11][1].valor
                        } 
                    ],
                    "multas": [
                        {
                            "mes": 1,
                            "valor": meses[0][11][8].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][11][8].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][11][8].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][11][8].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][11][8].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][11][8].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][11][8].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][11][8].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][11][8].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][11][8].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][11][8].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][11][8].valor
                        } 
                    ]
                },
                "totalCustosDespesas": [
                        {
                            "mes": 1,
                            "valor": meses[0][11][10].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][11][10].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][11][10].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][11][10].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][11][10].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][11][10].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][11][10].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][11][10].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][11][10].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][11][10].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][11][10].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][11][10].valor
                        } 
                     ],
                "outrasReceitasOperacionais": {
                    "variacoesCambiais": [{
                        "mes": 1,
                        "valor": meses[0][12][0].valor
                    },
                    {
                        "mes": 2,
                        "valor": meses[1][12][0].valor
                    },
                    {
                        "mes": 3,
                        "valor": meses[2][12][0].valor
                    },
                    {
                        "mes": 4,
                        "valor": meses[3][12][0].valor
                    },
                    {
                        "mes": 5,
                        "valor": meses[4][12][0].valor
                    },
                    {
                        "mes": 6,
                        "valor": meses[5][12][0].valor
                    },
                    {
                        "mes": 7,
                        "valor": meses[6][12][0].valor
                    },
                    {
                        "mes": 8,
                        "valor": meses[7][12][0].valor
                    },
                    {
                        "mes": 9,
                        "valor": meses[8][12][0].valor
                    },
                    {
                        "mes": 10,
                        "valor": meses[9][12][0].valor
                    },
                    {
                        "mes": 11,
                        "valor": meses[10][12][0].valor
                    },
                    {
                        "mes": 12,
                        "valor": meses[11][12][0].valor
                    } ],
                    "reversao": [ 
                        {
                            "mes": 1,
                            "valor": meses[0][12][7].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][12][7].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][12][7].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][12][7].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][12][7].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][12][7].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][12][7].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][12][7].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][12][7].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][12][7].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][12][7].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][12][7].valor
                        } 
                    ],
                    "subvencao": [

                        {
                            "mes": 1,
                            "valor": meses[0][12][9].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][12][9].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][12][9].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][12][9].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][12][9].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][12][9].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][12][9].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][12][9].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][12][9].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][12][9].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][12][9].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][12][9].valor
                        } 
                     ],
                    "lucrosDividendos": [
                        {
                            "mes": 1,
                            "valor": meses[0][12][13].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][12][13].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][12][13].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][12][13].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][12][13].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][12][13].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][12][13].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][12][13].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][12][13].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][12][13].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][12][13].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][12][13].valor
                        } 
                     ],
                    "ganhoAjuste": [ 
                        {
                            "mes": 1,
                            "valor": meses[0][12][16].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][12][16].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][12][16].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][12][16].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][12][16].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][12][16].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][12][16].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][12][16].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][12][16].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][12][16].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][12][16].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][12][16].valor
                        } 
                    ],
                    "total": [
                        {
                            "mes": 1,
                            "valor": isNaN(meses[0][12][18].valor)  ? 0 : meses[0][12][18].valor
                        },
                        {
                            "mes": 2,
                            "valor": isNaN(meses[1][12][18].valor) ? 0 : meses[1][12][18].valor
                        },
                        {
                            "mes": 3,
                            "valor": isNaN(meses[2][12][18].valor) ? 0 : meses[2][12][18].valor
                        },
                        {
                            "mes": 4,
                            "valor": isNaN(meses[3][12][18].valor) ? 0 : meses[3][12][18].valor
                        },
                        {
                            "mes": 5,
                            "valor": isNaN(meses[4][12][18].valor) ? 0 : meses[4][12][18].valor
                        },
                        {
                            "mes": 6,
                            "valor":isNaN(meses[5][12][18].valor) ? 0 : meses[5][12][18].valor
                        },
                        {
                            "mes": 7,
                            "valor": isNaN(meses[6][12][18].valor) ? 0 : meses[6][12][18].valor
                        },
                        {
                            "mes": 8,
                            "valor": isNaN(meses[7][12][18].valor) ? 0 : meses[7][12][18].valor
                        },
                        {
                            "mes": 9,
                            "valor": isNaN(meses[8][12][18].valor) ? 0 : meses[8][12][18].valor 
                        },
                        {
                            "mes": 10,
                            "valor": isNaN(meses[9][12][18].valor) ? 0 : meses[9][12][18].valor
                        },
                        {
                            "mes": 11,
                            "valor": isNaN(meses[10][12][18].valor) ? 0 :  meses[10][12][18].valor
                        },
                        {
                            "mes": 12,
                            "valor": isNaN(meses[11][12][18].valor) ? 0 : meses[11][12][18].valor 
                        } 
                     ],
                },
                "outrasDespesasOperacionais": {
                    "resultadoNegativo": [
                        {
                            "mes": 1,
                            "valor": meses[0][13][7].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][13][7].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][13][7].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][13][7].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][13][7].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][13][7].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][13][7].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][13][7].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][13][7].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][13][7].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][13][7].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][13][7].valor
                        } 
                    ],
                    "estimadas": [
                        {
                            "mes": 1,
                            "valor": meses[0][13][8].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][13][8].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][13][8].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][13][8].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][13][8].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][13][8].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][13][8].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][13][8].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][13][8].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][13][8].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][13][8].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][13][8].valor
                        } 
                    ],
                    "perdaValorJusto": [
                        {
                            "mes": 1,
                            "valor": meses[0][13][10].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][13][10].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][13][10].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][13][10].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][13][10].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][13][10].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][13][10].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][13][10].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][13][10].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][13][10].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][13][10].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][13][10].valor
                        } 
                    ],
                    "total": [
                        {
                            "mes": 1,
                            "valor": meses[0][13][12].valor
                        },
                        {
                            "mes": 2,
                            "valor": meses[1][13][12].valor
                        },
                        {
                            "mes": 3,
                            "valor": meses[2][13][12].valor
                        },
                        {
                            "mes": 4,
                            "valor": meses[3][13][12].valor
                        },
                        {
                            "mes": 5,
                            "valor": meses[4][13][12].valor
                        },
                        {
                            "mes": 6,
                            "valor": meses[5][13][12].valor
                        },
                        {
                            "mes": 7,
                            "valor": meses[6][13][12].valor
                        },
                        {
                            "mes": 8,
                            "valor": meses[7][13][12].valor
                        },
                        {
                            "mes": 9,
                            "valor": meses[8][13][12].valor
                        },
                        {
                            "mes": 10,
                            "valor": meses[9][13][12].valor
                        },
                        {
                            "mes": 11,
                            "valor": meses[10][13][12].valor
                        },
                        {
                            "mes": 12,
                            "valor": meses[11][13][12].valor
                        } 
                    ]
                }
            }

            )
            .then(res => res.data)
            .catch(err => console.log(err));
    },
}

